import { TranRecordModel } from "./tran-record.model";

export class DeleteATranModel {
    Trans: TranRecordModel[]
    Index: number
    intTotalIdx: number
    blnIsEstimate: boolean
    ActiveForm: string
    intClinicNo: number
    intClinicType: number
    ReturnName: boolean

    constructor(
        Trans: TranRecordModel[],
        Index: number,
        intTotalIdx: number,
        blnIsEstimate: boolean,
        ActiveForm: string,
        intClinicNo: number,
        intClinicType: number,
        ReturnName: boolean
    ) {
        this.Trans = Trans
        this.Index = Index
        this.intTotalIdx = intTotalIdx
        this.blnIsEstimate = blnIsEstimate
        this.ActiveForm = ActiveForm
        this.intClinicNo = intClinicNo
        this.intClinicType = intClinicType
        this.ReturnName = ReturnName
    }
}